import { ApiType } from "@gymflow/common";
import { useMutation } from "@tanstack/react-query";

export function useMutationSendEmailToLeads({ api }: { api: ApiType }) {
  return useMutation({
    mutationFn: async (
      payload: Parameters<ApiType["emailApi"]["sendEmailToLeads"]>[0],
    ) => {
      return (await api.emailApi.sendEmailToLeads(payload)).data;
    },
  });
}
